<table
  *ngIf="history && history.length > 0"
  class="table table-striped table-hover"
>
  <thead class="thead-dark">
    <th scope="col">Data</th>
    <th scope="col">Status</th>
    <th scope="col">Autor</th>
    <th scope="col">Justificativa</th>
  </thead>
  <tbody>
    <tr *ngFor="let item of history">
      <td>{{ item.moment | date: "dd/MM/yyyy HH:mm" }}</td>
      <td>{{ item.details }}</td>
      <td>{{ item.authorUserName }}</td>
      <td>{{ item.comments }}</td>
    </tr>
  </tbody>
</table>
